import { StateChutes } from '../../../utils/constants'
import { PreviewChutesProps, StateChute } from '../../../interfaces/chutes.d'
const { available, assigned, selected, not_available } = StateChutes

export const PreviewChutes = ({ chutes }: PreviewChutesProps) => {
    const styleChute = (state: StateChute) => {
        if (state === available)     return 'bg-[#F5F8FB]'
        if (state === assigned)      return 'bg-[#F1F9EC]'
        if (state === selected)      return 'bg-[#E2E8F0] text-[#94A3B8]'
        if (state === not_available) return 'bg-[#F1F5F9] text-[#94A3B8]'
    }

    return (
        <div className="flex flex-wrap gap-2">
            {chutes.map(({ number, state }, i) => (
                <h2
                    key={i}
                    className={`${styleChute(
                        state
                    )} w-[32px] h-[32px] flex justify-center items-center rounded-[50px]`}
                >
                    {number}
                </h2>
            ))}
        </div>
    )
}
